import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-prom',
  templateUrl: './prom.component.html',
  styleUrls: ['./prom.component.scss'],
})
export class PromComponent {
  menuOpen = false;

  reviews = [
    {
      text: 'prom_page.testimonials_1_text',
      author: 'prom_page.testimonials_1_author',
    },
    {
      text: 'prom_page.testimonials_2_text',
      author: 'prom_page.testimonials_2_author',
    },
  ];

  protected faqList = [
    {
      question: 'prom_page.faq_1_question',
      answer: 'prom_page.faq_1_answer'
    },
    {
      question: 'prom_page.faq_2_question',
      answer: 'prom_page.faq_2_answer'
    },
    {
      question: 'prom_page.faq_3_question',
      answer: 'prom_page.faq_3_answer'
    },
    {
      question: 'prom_page.faq_4_question',
      answer: 'prom_page.faq_4_answer'
    },
    {
      question: 'prom_page.faq_5_question',
      answer: 'prom_page.faq_5_answer'
    },

  ]

  protected promRules = [
    {
      rule: 'prom.rule_1'
    },
    {
      rule: 'prom.rule_2'
    },
    {
      rule: 'prom.rule_3'
    },
    {
      rule: 'prom.rule_4'
    },
    {
      rule: 'prom.rule_5'
    },
  ]
  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;

}
